import moment from 'moment';

export class SumupGroup {
  nendo: number | null = null
  exec_date: string = null
  name: string = null
  verify_count: number | null
  is_sort_answer_image_enable: boolean = false
  is_print_part1: boolean = false
}

export class Examinee{
  id: number | null
  student_no: number | null
  student_no_character: string
  student_name: string
  room_name: string
  cram_school_name: string
  cram_room_name: string
  email: string
  phone_no: string
  applied_type: number
  user_id: number
  passing_state_fixed: string
  result_published: boolean

  constructor(examinee: any){
    this.id = examinee.id;
    this.student_no = examinee.student_no == undefined ? null : examinee.student_no;
    this.student_no_character = examinee.student_no_character == undefined ? null : `${examinee.student_no_character}`;
    this.student_name = examinee.student_name;
    this.room_name = examinee.room_name;
    this.cram_school_name = examinee.cram_school_name;
    this.cram_room_name = examinee.cram_room_name;
    this.email = examinee.email;
    this.phone_no = examinee.phone_no;
    this.applied_type = examinee.applied_type;
    this.user_id = examinee.user_id;
    this.passing_state_fixed = examinee.passing_state_fixed;
    this.result_published = examinee.result_published;
  }
}
